import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const createPlanSelectOption = (planId: string | number): ISelectOption => ({
  id: String(planId),
  label: String(planId),
  value: String(planId),
});
